module.exports = __webpack_public_path__ + "static/media/p34.f7469f0b.jpg";